module.exports = __webpack_public_path__ + "static/media/Info_Icon.d5fcc992.svg";